import { useTeamChatApi } from '../team-chat-api-providers/use-team-chat-api';
import { useGetUserFromConversation } from './use-get-users-from-conversation';

// This hook is only be used to conditionally fetch users from a conversation or the older way from stream directly
/* 
  If the feature flag is disabled to fetch users from stream we go the older way
  If the feature flag is enabled we go the newer way of fetching users from conversation members
  The return type in both the cases should overall match
  Returns:
  otherUsers:  TeamChatTypes.User[]
  isLoadingUsers: boolean
  isUsersFetched: boolean
  refetchUsers: () => Promise<...>
  setUsers: (updater: (prevUsers: TeamChatTypes.User[] | undefined) => TeamChatTypes.User[]) => void
  _removeUsers: () => void
*/

export const useGetUsers = ({
  api,
  shouldFetchConversationUsers,
  conversationQueryKey,
}: {
  api: 'stream' | 'mock';
  conversationQueryKey: string[];
  shouldFetchConversationUsers: boolean;
}) => {
  const { useQueryUsers } = useTeamChatApi(api);

  const {
    data: otherUsersFromStream,
    isLoading: isLoadingUsersFromStream,
    isFetched: isUsersFetchedFromStream,
    remove: _removeUsersFromStreamQuery,
    error: streamUsersError,
    refetch: refetchStreamUsers,
    set: setStreamUsers,
  } = useQueryUsers({ enabled: !shouldFetchConversationUsers });

  const cacheUsersQueryData = useGetUserFromConversation({
    api,
    conversationQueryKey,
    enabled: shouldFetchConversationUsers,
  });

  if (shouldFetchConversationUsers) {
    return cacheUsersQueryData;
  }

  return {
    otherUsers: otherUsersFromStream,
    isLoadingUsers: isLoadingUsersFromStream,
    isUsersFetched: isUsersFetchedFromStream,
    usersError: streamUsersError,
    refetchUsers: refetchStreamUsers,
    setUsers: setStreamUsers,
    _removeUsers: _removeUsersFromStreamQuery,
  };
};
